// Base styles
import * as switchButtonStatic from "assets/components-static-styles/components/form/switchButton";
import colors from "assets/theme/base/colors";

// Helper functions
import { merge } from "lodash";
import linearGradient from "assets/theme/functions/linearGradient";

const { white, gradients, grey, transparent } = colors;

// types
type Types = any;

const themeStyles = {
  styleOverrides: {
    switchBase: {
      color: gradients.dark.main,

      "&:hover": {
        backgroundColor: transparent.main,
      },

      "&.Mui-checked": {
        color: gradients.dark.main,

        "&:hover": {
          backgroundColor: transparent.main,
        },

        "& .MuiSwitch-thumb": {
          borderColor: `${gradients.greenButton.main} !important`,
        },

        "& + .MuiSwitch-track": {
          background: `${linearGradient(
            gradients.greenButton.main,
            gradients.greenButton.dark
          )} !important`,
          borderColor: `${gradients.greenButton.main} !important`,
        },
      },

      "&.Mui-focusVisible .MuiSwitch-thumb": {
        backgroundImage: linearGradient(gradients.greenButton.main, gradients.greenButton.state),
      },
    },

    thumb: {
      backgroundColor: white.main,
      borderColor: grey[400],
    },

    track: {
      backgroundColor: grey[400],
      borderColor: grey[400],
    },

    checked: {},
  },
};

const switchButton: Types = merge(themeStyles, switchButtonStatic.default);

export default switchButton;
